import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from 'legacyStyles';

const styles = theme => ({
  root: {
    ...theme.typography.p1,
    color: theme.palette.common.noir.medium,
    textAlign: 'left',
    padding: `${theme.spacing.s8}px ${theme.spacing.s16}px`,
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    [theme.breakpoints.match('md')]: {
      ...theme.typography.p4,
      padding: theme.spacing.s8,
    },
    '&:focus': {
      background: 'rgba(0,0,0,0.14)',
    },
  },
  highlighted: {
    background: 'lightgray',
  },
  selected: {
    fontWeight: 'bold',
  },
});

const AutoCompleteItem = ({ classes, children, isHighlighted, isSelected, ...props }) => (
  <li
    className={classNames(classes.root, {
      [classes.highlighted]: isHighlighted,
      [classes.selected]: isSelected,
    })}
    {...props}
  >
    {children}
  </li>
);
AutoCompleteItem.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  children: PropTypes.string.isRequired,
  isHighlighted: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
};

export default withStyles(styles)(AutoCompleteItem);
